class MultiCtrlFlag {
    constructor(callback) {
        this._callback = callback;
        this._keys = new Set();
    }

    set(key, value) {
        value = Boolean(value);
        if (value === this._keys.has(key)) return;

        let call;

        if (value) {
            call = this._keys.size === 0;
            this._keys.add(key);
        } else {
            this._keys.delete(key);
            call = this._keys.size === 0;
        }

        if (call) {
            this._callback(value);
        }
    }
}

export default MultiCtrlFlag;
